/** 2단계 이메일 인증 코드 입력 만료 시간 (ms) */
export const AUTH_CODE_EXPIRATION_TIME = 300 * 1000;

/** 2단계 이메일 인증 코드 재전송 대기 시간 (ms) */
export const AUTH_CODE_RESEND_DELAY = 30 * 1000;
